import type { SVGProps } from 'react'

export const MessageCircleIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M6.58366 16.6666C8.17414 17.4825 10.0037 17.7035 11.7427 17.2898C13.4817 16.876 15.0158 15.8548 16.0685 14.4101C17.1211 12.9654 17.6232 11.1922 17.4841 9.41009C17.3451 7.62797 16.5741 5.9541 15.3102 4.69012C14.0462 3.42614 12.3723 2.65517 10.5902 2.51614C8.80807 2.37711 7.03488 2.87916 5.59018 3.93183C4.14547 4.9845 3.12423 6.51855 2.71051 8.25755C2.29679 9.99655 2.51778 11.8261 3.33366 13.4166L1.66699 18.3333L6.58366 16.6666Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
